module.exports = __webpack_public_path__ + "static/media/TMDB-logo.86ff7c17.svg";